import * as api from "../api";
import axios from "axios";
// import router from '../routerManuaConfig'
import Vue from "vue";
let base = api.BaseApiUrl;

//订单管理
export const PostSelectOrderList = (params) => {
  return axios.post(`${base}/api/OrderManagerment/PostSelectOrderList`, params);
};
export const DeleteOrder = (params) => {
  return axios.delete(`${base}/api/OrderManagerment/DeleteOrder`, {
    params: params,
  });
};

export const SendDeliveryConfirmationMessage = (OrderId) => {
  return axios.get(
    `${base}/api/OrderManagerment/GetUpdateOrderStatus?OrderId=${OrderId}`
  );
};

//导出列表
export const PostExportOrderExcel = (params) => {
  return axios.post(
    `${base}/api/OrderManagerment/PostExportExcelOrder`,
    params,
    {
      responseType: "blob",
    }
  );
};
